export const tceq = {
    agencyCode: '582',
    name: 'Texas Commission on Environmental Quality',
    shortName: 'TCEQ',
    slug: 'tceq',
  };
  